import { render, staticRenderFns } from "./PorTipoAtoInfralegal.vue?vue&type=template&id=31959f76&scoped=true"
import script from "./PorTipoAtoInfralegal.vue?vue&type=script&lang=js"
export * from "./PorTipoAtoInfralegal.vue?vue&type=script&lang=js"
import style0 from "./PorTipoAtoInfralegal.vue?vue&type=style&index=0&id=31959f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31959f76",
  null
  
)

export default component.exports